import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_BUTTON_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_SUBMIT_BUTTON_TYPE = 'postermywall-submit-button';
const SUBMIT_BUTTON_ID = 'postermywall-submit-button';
const FORM_BUTTON_DATA_ATTR = 'data-is-pmw-form-button';

export const POSTERMYWALL_SUBMIT_BUTTON: AddComponentTypeOptions = {
  extend: 'text',
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    const isSubmitTag = el.tagName === 'BUTTON' || el.tagName === 'INPUT';
    return isSubmitTag && el.getAttribute(FORM_BUTTON_DATA_ATTR) !== null && el.id === SUBMIT_BUTTON_ID ? {type: POSTERMYWALL_SUBMIT_BUTTON_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'input',
      void: true,
      name: window.i18next.t('pmwjs_form_maker_name_button'),
      icon: 'icon-button',
      removable: false,
      toolbar: [],
      selectable: true,
      highlightable: false,
      badgable: true,
      editable: true,
      draggable: false,
      attributes: {
        id: SUBMIT_BUTTON_ID,
        [FORM_BUTTON_DATA_ATTR]: '1',
        'data-pmw-type': POSTERMYWALL_SUBMIT_BUTTON_TYPE,
        class: 'pmw-content-button',
        type: 'submit',
        value: 'Submit',
      },
      style: FORM_BUTTON_STYLES,
    },
  },
};
